import { useFormContext } from 'react-hook-form';
import { useI18n } from '@react/i18n';
import { CheckoutFormValues, CheckoutState } from '../types';
import Field from './Field';

interface Props {
    state: CheckoutState;
    /** URL kroku doprava a platba (per-site z routeru: /basket/... vs. /kosik/...) */
    backUrl: string;
    /** Smartform našeptávač aktivní → přidat jeho CSS třídy na adresní pole */
    smartform?: boolean;
    /** pole zamcena po autofillu z registru (ARES/VIES) */
    lockedFields?: string[];
}

/** Fakturační adresa; stát je fixovaný z předchozího kroku košíku. */
export default function BillingAddressSection({ state, backUrl, smartform = false, lockedFields = [] }: Props) {
    const sf = (cls: string) => (smartform ? ` smartform-instance-fakturacni ${cls}` : '');
    const isLocked = (path: string) => locked || lockedFields.includes(path);
    const t = useI18n();
    const { register } = useFormContext<CheckoutFormValues>();
    const locked = state.customer?.isPartnerLocked ?? false;
    const isPickup = state.pickupPoint !== null;

    return (
        <fieldset>
            <div className="mt-7">
                <p className="basket__title">{t('Fakturační adresa')}</p>

                <Field name="billing.street" label={t('Ulice a číslo popisné')} required>
                    <input
                        id="frm-billing-street"
                        className={`form-control${sf('smartform-street-and-number')}`}
                        autoComplete={smartform ? 'off' : 'street-address'}
                        readOnly={isLocked('billing.street')}
                        {...register('billing.street', { required: t('Zadejte prosím ulici a č.p.') })}
                    />
                </Field>

                <Field name="billing.city" label={t('Město')} required={!isPickup}>
                    <input
                        id="frm-billing-city"
                        className={`form-control${sf('smartform-city')}`}
                        autoComplete="address-level2"
                        readOnly={isLocked('billing.city')}
                        {...register('billing.city', isPickup ? {} : { required: t('Zadejte prosím město') })}
                    />
                </Field>

                <div className="clearfix">
                    <div className="form-group col-xm-2 no-padding--left">
                        <label className="control-label" htmlFor="frm-billing-zip">{t('PSČ')} {!isPickup && <span>*</span>}</label>
                        <input
                            id="frm-billing-zip"
                            className={`form-control${sf('smartform-zip')}`}
                            autoComplete="postal-code"
                            maxLength={10}
                            readOnly={isLocked('billing.zip')}
                            {...register('billing.zip', isPickup ? {} : { required: t('Zadejte prosím PSČ') })}
                        />
                    </div>
                </div>

                <div className="clearfix">
                    <div className="form-group col-xm-6 col-md-5 no-padding--left">
                        <label className="control-label">{t('Stát')} <span>*</span></label>
                        <select className="form-control" disabled style={{ pointerEvents: 'none' }}>
                            <option>{state.countryName}</option>
                        </select>
                        {state.market === 'international' && (
                            <p
                                className="help-block text-muted small"
                                dangerouslySetInnerHTML={{ __html: t("You can change the delivery country in <a href='%s'>the previous step</a> of the cart.").replace('%s', backUrl) }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </fieldset>
    );
}
